import config from 'app/config';
import { isAuth0User } from 'services/authentication';
import getSessionUrl from './get-session-url';

const getInsightsUrl = showId => {
  const baseUrl = `${config.get('INSIGHTS_HOST')}${showId ? `/shows/${showId}` : ''}`;
  const session = getSessionUrl({ appUrl: '', loginPath: '' });

  if (isAuth0User()) {
    return baseUrl;
  }

  return `${baseUrl}?session=${session}`;
};

export default getInsightsUrl;
